export const CONFIG_DOMAIN = 'PostFinanceCheckoutPayment.config';
export const CONFIG_APPLICATION_KEY = CONFIG_DOMAIN + '.' + 'applicationKey';
export const CONFIG_EMAIL_ENABLED = CONFIG_DOMAIN + '.' + 'emailEnabled';
export const CONFIG_INTEGRATION = CONFIG_DOMAIN + '.' + 'integration';
export const CONFIG_LINE_ITEM_CONSISTENCY_ENABLED = CONFIG_DOMAIN + '.' + 'lineItemConsistencyEnabled';
export const CONFIG_SPACE_ID = CONFIG_DOMAIN + '.' + 'spaceId';
export const CONFIG_SPACE_VIEW_ID = CONFIG_DOMAIN + '.' + 'spaceViewId';
export const CONFIG_STOREFRONT_INVOICE_DOWNLOAD_ENABLED = CONFIG_DOMAIN + '.' + 'storefrontInvoiceDownloadEnabled';
export const CONFIG_USER_ID = CONFIG_DOMAIN + '.' + 'userId';
export const CONFIG_STOREFRONT_WEBHOOKS_UPDATE_ENABLED = CONFIG_DOMAIN + '.' + 'storefrontWebhooksUpdateEnabled';
export const CONFIG_STOREFRONT_PAYMENTS_UPDATE_ENABLED = CONFIG_DOMAIN + '.' + 'storefrontPaymentsUpdateEnabled';

// References vendor/shopware/core/Defaults.php::SALES_CHANNEL_TYPE_STOREFRONT
export const STOREFRONT_SALES_CHANNEL_TYPE_ID = '8a243080f92e4c719546314b577cf82b';

export default {
    CONFIG_DOMAIN,
    CONFIG_APPLICATION_KEY,
    CONFIG_EMAIL_ENABLED,
    CONFIG_INTEGRATION,
    CONFIG_LINE_ITEM_CONSISTENCY_ENABLED,
    CONFIG_SPACE_ID,
    CONFIG_SPACE_VIEW_ID,
    CONFIG_STOREFRONT_INVOICE_DOWNLOAD_ENABLED,
    CONFIG_USER_ID,
    CONFIG_STOREFRONT_WEBHOOKS_UPDATE_ENABLED,
    CONFIG_STOREFRONT_PAYMENTS_UPDATE_ENABLED,
    STOREFRONT_SALES_CHANNEL_TYPE_ID
};
